var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('label',[_c('span',{attrs:{"id":"label_span"}},[_vm._v(_vm._s(_vm.label))]),_c('input',_vm._g({attrs:{"id":"input","type":"text"},domProps:{"value":_vm.value}},_vm.$events))])])}
var staticRenderFns = []

export { render, staticRenderFns }